import React from "react";
import i18n from "../../script/i18n";
import intl from "react-intl-universal";
import { createRoot } from "react-dom/client";
import { Route, Switch, Redirect } from "wouter";
import { ThemeProvider } from "styled-components";
import { GlobalStyle, theme } from "../components/GlobalStyle";

import authUtils from "../../script/utils/authUtils";

import { Users } from "./Users";
import { Login } from "./Login";
import { Entry } from "./Entry";
import { Entries } from "./Entries";
import { Runners } from "./Runners";
import { NotFound } from "./NotFound";
import { Settings } from "./Settings";
import { Antennas } from "./Antennas";
import { Document } from "./Document";
import { Documents } from "./Documents";
import { WorstcaseData } from "./WorstcaseData";
import { UpdateDialog } from "../components/Update";
import { UserProvider } from "../contexts/UserContext";
import { VersionProvider } from "../contexts/VersionContext";
import { MultiRadios } from "./entry/radios/MultiRadios";
import { ExceptionDialog } from "../components/Exception";
import { AgreementDialog } from "./agreement/AgreementDialog";

const AnonymousRoute = props => {
    const renderChildren = authUtils.isAuthenticated() ? <Redirect to="/entries" /> : props.children;
    return <Route path={props.path}>{renderChildren}</Route>;
};

const AuthenticatedRoute = props => {
    const renderChildren = authUtils.isAuthenticated() ? props.children : <Redirect to="/" />;
    return <Route path={props.path}>{renderChildren}</Route>;
};

export const Root = () => {
    i18n.init("de");
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <Switch>
                <AnonymousRoute path="/"><Login /></AnonymousRoute>
                <AnonymousRoute path="/login"><Login /></AnonymousRoute>
                <UserProvider>
                    <VersionProvider>
                        <AuthenticatedRoute path="/entries"><Entries /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/entry/:entryId/:param1/:param2?">
                            {params => <Entry entryId={params.entryId} urlParam1={params.param1} urlParam2={params.param2} />}
                        </AuthenticatedRoute>
                        <AuthenticatedRoute path="/multiEntries/:entryId">{params => <MultiRadios entryId={params.entryId} />}</AuthenticatedRoute>
                        <AuthenticatedRoute path="/antennas"><Antennas /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/news"><Document title={intl.get("navigation.news")} url={"/rest/resource/document/news.pdf"} /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/manual"><Document title={intl.get("navigation.manual")} url={"/rest/resource/document/manual.pdf"} /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/agreement"><Document title={intl.get("navigation.agreement")} url={"/rest/resource/document/agreement.pdf"} /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/settings"><Settings /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/users"><Users /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/runners"><Runners /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/documents"><Documents /></AuthenticatedRoute>
                        <AuthenticatedRoute path="/worstcaseData"><WorstcaseData /></AuthenticatedRoute>
                        <AgreementDialog />
                    </VersionProvider>
                </UserProvider>
                <Route><NotFound /></Route>
            </Switch>
            <UpdateDialog />
            <ExceptionDialog />
            <div id="dialog" />
        </ThemeProvider>
    );
};

createRoot(document.getElementById("root")).render(<Root />);